angular.module('Directives')
    .directive('bbaStepsBar',

        function(toastr){
            return {
                restrict: 'E',
                templateUrl: '/templates/directives/bbaStepsBar.html',
                replace: true,
                scope: {
                    stepsData: '=?',
                    ngDisabled: '=?'
                },
                link: bbaSwitchLink
            };

            function bbaSwitchLink($scope, $element, $attrs){
                $scope.testAffix = $attrs.name;
                $scope.getActiveStep = getActiveStep;
                $scope.setActiveStep = setActiveStep;
                $scope.getInvalidStep = getInvalidStep;

                const statusInvalid =[
                    'cancelled',
                    'missing',
                    'damaged'
                ];

                function setActiveStep(step) {
                    if(!$scope.ngDisabled){
                        angular.forEach($scope.stepsData, item=>{
                            if(item.isActive){
                                if(item.form) {
                                    item.form.$setSubmitted();
                                }
                                if(item.validateFn) {
                                    item.validateFn(item);
                                }
                            }
                            item.isActive = false;
                        });
                        if(step.validateForms){
                            let incompleteForm = $scope.stepsData.find(item=>{
                                item.form.$setSubmitted();
                                item.validateFn(item);
                                return item.form.$invalid || !item.isValid;
                            });
                            if(incompleteForm){
                                toastr.warning('Please fill the required fields with valid values');
                                incompleteForm.isActive = true;
                                return false;
                            }
                        }
                        step.isActive = true;
                    }
                }
                function getActiveStep(step) {
                    const activeStatus = $scope.stepsData.find(item=>item.isActive);
                    const invalidStatus = statusInvalid.includes(activeStatus.value);

                    if(!invalidStatus) {
                        if(step.isActive ){
                            return true;
                        }
                        const active = $scope.stepsData.findIndex(item=>item.isActive);
                      
                        if($scope.stepsData.indexOf(step) < active){
                            return true;
                        }
                    }
                    
                }

                function getInvalidStep(step) {
                    const activeStatus = $scope.stepsData.find(item=>item.isActive);
                    const invalidStatus = statusInvalid.includes(activeStatus.value);

                    if(invalidStatus){
                         if(step.isActive){
                            return true;
                        }
                        const active = $scope.stepsData.findIndex(item=>item.isActive);
                    
                        if($scope.stepsData.indexOf(step) < active){
                            return true;
                        }
                    }

                   
                }
            };
        });


// WEBPACK FOOTER //
// ./js/directives/bbaStepsBar.js